export default "__VITE_ASSET__BVjRPj8K__"